import { createFileRoute } from '@tanstack/react-router';
import { CategoriesPage } from '@/pages/menu/categories';
import { requireAuth } from '../require-auth';
import { menuSearchSchema } from '../menu-search';

// No loader prefetch: the catalog is keyed by the active branch, which is only
// known once the branch list has loaded (see `useMerchantScope`). Prefetching
// here would either fire with an empty scope or duplicate the branch request,
// so the page's own query owns the fetch.
export const Route = createFileRoute('/eats/menu_/categories')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: menuSearchSchema,
  component: CategoriesRoute,
});

function CategoriesRoute() {
  const { search, status, categoryStatus, categoryId, allBranches, showcase } =
    Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CategoriesPage
      search={search}
      status={status}
      categoryStatus={categoryStatus}
      categoryId={categoryId}
      allBranches={allBranches ?? true}
      showcase={showcase ?? false}
      onToggleShowcase={() => {
        void navigate({
          search: (prev) => ({
            ...prev,
            showcase: prev.showcase ? undefined : true,
          }),
        });
      }}
    />
  );
}
